import {
  AfterContentChecked,
  AfterViewInit,
  Component,
  OnInit,
} from "@angular/core";
import { ICapitolato } from "../_interfaces/ICapitolato";
import { UsatiService } from "./services/usati.service";
import { ActivatedRoute } from "@angular/router";
import { FormGroup } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-usati-lista",
  templateUrl: "./usati-lista.component.html",
  styleUrls: ["./usati-lista.component.scss"],
})
export class UsatiListaComponent
  implements OnInit, AfterViewInit, AfterContentChecked
{
  arr: Array<ICapitolato> = [];
  searchFilter: string;

  form: FormGroup;

  loggato: boolean;
  spin: boolean;

  tipologie: Array<any> = [];
  pratiche: Array<any> = [];

  constructor(
    private service: UsatiService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
  ) {
    this.form = this.service.creaFormGroup();
    this.spin = false;
    this.searchFilter = "";
  }

  async ngOnInit(): Promise<void> {
    this.loggato =
      localStorage.getItem("orion-usati-password") &&
      localStorage.getItem("orion-usati-password") === "1"
        ? true
        : false;
    const result = await this.service
      .ricerca<any>("veicolo/tipologia/", null)
      .toPromise();
    this.tipologie = result.data;
  }

  ngAfterContentChecked() {
    const app = localStorage.getItem("orion-filtri-home");

    if (app) {
      this.form.patchValue(JSON.parse(app));
      localStorage.setItem("orion-filtri-home", "");
    }
  }

  ngAfterViewInit() {
    this.ricerca();
  }

  ricercaInvio(key) {
    // console.log(key);
    // console.log(key.srcElement);
    // key.srcElement.tab
    // if (key.keyCode === 13) {
    //   console.log(this.form.value);
    // key.preventDefault();
    // key.stopPropagation();
    // const el = document.getElementById('cancella');
    // el.focus();
    // var self = $(this), form = self.parents('form:eq(0)'), focusable, next;
    // focusable = form.find('input,a,select,button,textarea').filter(':visible');
    // next = focusable.eq(focusable.index(this)+1);
    // if (next.length) {
    //   next.focus();
    // } else {
    //   form.submit();
    // }
    // return false;
    // key.preventDefault();
    //
    // const el = document.getElementById('ricerca');
    // el.focus();
    // // el.click();
    // this.ricerca();
    // }
  }

  async ricerca(): Promise<void> {
    const record = this.form.value;

    this.pratiche = [];
    this.spin = true;

    record.loggato = this.loggato;

    const result = await this.service
      .ricercaParams<any>("veicolo/0/web/", record)
      .toPromise();
    // this.service.ricercaParams('usati/0/web/', record, result => {
    this.pratiche = result.data;

    this.spin = false;

    this.pratiche.forEach((p) => {
      if (p.foto && p.foto.length > 0) {
        this.service
          .getImage(
            `veicolo/${p.IDvcl}/web/download/immagine/`,
            p.foto[0].nomeFileFoto,
          )
          .subscribe((result1) => {
            if (result1) {
              const file = new Blob([result1], { type: "application/jpg" }),
                fileURL = window.URL.createObjectURL(file);

              p.imageToShow = this.sanitizer.bypassSecurityTrustUrl(fileURL);
              p.fileURL = fileURL;
            }
          });
      } else {
        this.service
          .getImage("veicolo/xxx/web/download/immagine/", "")
          .subscribe((result1) => {
            if (result1) {
              const file = new Blob([result1], { type: "application/jpg" }),
                fileURL = window.URL.createObjectURL(file);

              p.imageToShow = this.sanitizer.bypassSecurityTrustUrl(fileURL);
              p.fileURL = fileURL;
            }
          });
      }
    });
  }

  cancella() {
    this.form.setValue(this.service.settaFormGroup({}));
    this.ricerca();
  }

  //
  // openModal(pratica) {
  //
  //   console.log(pratica);
  //   this.pratica = pratica;
  //   this.modal = true;
  // }
  //
  // closeModal() {
  //   this.modal = false;
  // }
}
